import React from 'react';

class WordQuestErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" style={{ minHeight: '100vh', display: 'grid', placeContent: 'center', gap: 16, padding: 24, boxSizing: 'border-box', background: '#fbfaff', textAlign: 'center' }}>
        <h1>Word Quest could not load</h1>
        <p>Please reload or return to SwiftUni.</p>
        <button type="button" onClick={() => window.location.reload()} style={{ minHeight: 44 }}>Reload</button>
        <a href="/">Return to SwiftUni</a>
      </div>
    );
  }
}

export default WordQuestErrorBoundary;
